import React from 'react';

/**
 * Moldura de celular usada para exibir a prévia da página pública dentro da
 * tela de configuração. Puramente visual.
 */
const PhoneFrame = ({ children }) => (
  <div className="fsl-phone">
    <div className="fsl-phone-notch" aria-hidden />
    <div className="fsl-phone-side fsl-phone-side--power" aria-hidden />
    <div className="fsl-phone-side fsl-phone-side--vol1" aria-hidden />
    <div className="fsl-phone-side fsl-phone-side--vol2" aria-hidden />
    <div className="fsl-phone-screen">{children}</div>
  </div>
);

export default PhoneFrame;
